/**
 * An event emitter allowing for the registration and triggering of named events.
 */
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.events = [];
        this.id = 0;
    }
    /**
     * Subscribe to a named event
     *
     * @param {string} name The event name
     * @param {Function} callback The callback to invoke when the event is triggered
     * @param {any} context A context to bind to the callback
     * @returns {EventEmitter} The emitter
     */
    EventEmitter.prototype.on = function (name, callback, context) {
        if (this.events.findIndex(function (e) { return e.name === name && e.callback === callback; }) >= 0) {
            throw new Error("Cannot add duplicate name & callback pair.");
        }
        if (typeof callback !== 'function') {
            throw new Error("Callback must be a function");
        }
        this.events.push({
            name: name,
            callback: callback,
            context: context
        });
        return this;
    };
    /**
     * Unsubscribe to an event. This will unsubscribe from events matching the minimum criteria passed.
     * e.g. if only name is passed then *all* events registered with that name will be removed.
     * *Note* that for the moment context may be passed in to this function but will not be considered
     * when determining whether to remove the callback
     *
     * @param {string} name The event name to unregister
     * @param {Function} callback The function that's been previously registered
     * @param {any} [context] The context with which it was registered
     * @returns {EventEmitter} The emitter
     */
    EventEmitter.prototype.off = function (name, callback, context) {
        this.events = this.events.filter(function (e) {
            return (e.name !== name && name) ||
                (e.callback !== callback && callback);
        });
        return this;
    };
    /**
     * Bind an event but remove the binding the first time it's triggered
     *
     * @param {string} name The event name
     * @param {Function} callback The callback function
     * @param {*} [context] The context to bind to the callback
     * @returns {EventEmitter} The emitter
     */
    EventEmitter.prototype.once = function (name, callback, context) {
        var _this = this;
        var cb = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.off(name, cb, context);
            callback.apply(_this, args);
        };
        return this.on(name, cb, context);
    };
    /**
     * Trigger an event
     *
     * @param {string} name The event to trigger
     * @param {...any[]} args The arguments to call with the event
     * @returns {EventEmitter} The emitter
     */
    EventEmitter.prototype.trigger = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.events.filter(function (e) {
            return e.name === name;
        }).forEach(function (e) {
            e.callback.apply(e.context, args);
        });
        return this;
    };
    /**
     * Create an API for a single event
     *
     * @param {string} name The event name
     * @returns {EventApi}
     */
    EventEmitter.prototype.event = function (name) {
        var _this = this;
        var that = this;
        if (!name) {
            name = '__auto_' + that.id++;
        }
        var partial = function (op) {
            return function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                op.apply(_this, (_a = [name]).concat.apply(_a, args));
                return _this;
            };
        };
        return {
            on: partial(this.on),
            off: partial(this.off),
            once: partial(this.once),
            trigger: partial(this.trigger)
        };
    };
    return EventEmitter;
}());
export { EventEmitter };
/**
 * Create a new event emitter.
 *
 * @export
 * @returns {EventEmitter} The emitter
 */
export default function () {
    return new EventEmitter();
}
;
//# sourceMappingURL=pubsub.js.map